import {Route, Routes} from 'react-router-dom';
import {ListAgencyWorkspacesPage} from '../pages/list-agency-workspaces-page/list-agency-workspaces-page';

export const AgencyRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<ListAgencyWorkspacesPage />} />
    </Routes>
  );
};
